const CUSTOM_SYM = Symbol.for('__cld-rdx-custom-creator__');

export const getCustomCreator = (creator) => ({
  [CUSTOM_SYM]: true,
  creator,
});

export const createAction = (type, payload) => ({
  type,
  payload,
});

/**
 * Creates an object map of keys and action creators
 */
export default (types, overrides) => {
  const typeNames = Array.isArray(types) ? types : Object.values(types);

  return typeNames.reduce((res, type) => {
    //store an action creator for type
    res[type] = (...args) =>
      overrides?.[type]?.[CUSTOM_SYM]
        ? //use a custom creator
          overrides[type].creator(...args)
        : //use a simple action creator
          createAction(
            type,
            overrides?.[type]
              ? //use a payload parser function
                overrides?.[type](...args)
              : //use the first arg as the payload
                args[0]
          );

    return res;
  }, {});
};
